module.exports = "images/teamed_image_12.png";